// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"288":"804f4272","497":"804f4272","966":"430f23db"}[chunkId] + ".css";
};